<script>
	import Siema from 'siema'
	import next from 'array-next'
	import prev from 'array-previous'
	import { fade } from 'svelte/transition'

	export let images = []
	export let arrowImage = '/wp-content/uploads/2020/07/slider-arrow.png'

	let activeImage = images[0]

	let carousel

	let height = 0
	let transition

	$: prevImage = prev(images, activeImage)
	$: nextImage = next(images, activeImage)

	function initCarousel(node) {
		carousel = new Siema({
			selector: node,
			duration: 600,
			easing: 'ease',
			onChange: () => (activeImage = images[carousel.currentSlide]),
		})
	}

	$: if (height && !transition) {
		setTimeout(() => {
			transition = true
		}, 0)
	}
</script>

<style>
	.transition {
		transition: padding 0.5s;
	}
	.tt {
		position: absolute;
	}
	.outer-wrap {
		position: relative;
	}
</style>

<div class="outer-wrap">
	<div class="boost-carousel" use:initCarousel>
		{#each images as image}
			<div
				class="carousel-item"
				class:prev-item={image === prevImage}
				class:next-item={image === nextImage}>
				<div class="lozad" data-background-image={image.src} />
			</div>
		{/each}
	</div>
	<button class="prev">
		<img src={arrowImage} alt="previous" on:click={() => carousel.prev()} />
	</button>
	<button class="next">
		<img src={arrowImage} alt="next" on:click={() => carousel.next()} />
	</button>
</div>

<div
	class="carousel-caption"
	class:transition
	style="padding-bottom:{height}px">
	<div class="tt" bind:clientHeight={height}>
		{#each [activeImage] as image (image.src)}
			{#if image.caption}
				<p transition:fade={{ duration: 300 }}>{image.caption}</p>
			{/if}
		{/each}
	</div>
	{#if activeImage.caption}
		<span
			in:fade={{ delay: 300, duration: 200 }}
			out:fade={{ duration: 300 }} />
	{/if}
</div>
